import CasinoTV from "../../components/CasinoTV.jsx";
import React, { useEffect } from "react";
import {
  getCasinoExposureAPI,
  getUniversalCasinoLastResultAPI,
  getUniversalCasinoOddsAPI,
  uniCasinoBetAPI,
} from "../../service/casino";
import { useLocation } from "react-router-dom";
import {
  getUniversalCasinoPlExposureByRunner,
  GetUniversalLastTenResult,
} from "./genericFunctions";
import PlaceBetUniversal from "./PlaceBetUniversal";
import toast from "react-hot-toast";
import GenericCasinoTimer from "../../components/GenericCasinoTimer";

export default function OneDayTeenPatti() {
  const GAME_ID = useLocation().pathname.split("/")[2];
  const [odds, setOdds] = React.useState({});
  const [lastResult, setLastResult] = React.useState({});
  const [exposure, setExposure] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [timer, setTimer] = React.useState(0);
  const [showWinnerOverlay, setShowWinnerOverlay] = React.useState(false);
  const [placeBetPayload, setPlaceBetPayload] = React.useState({
    amount: 0,
    back: 0,
    casinoGames: GAME_ID,
    marketId: "",
    runnerName: "",
    marketIdWithSelectionId: "",
    type: "back",
  });
  const roundIdRef = React.useRef();
  const getOdds = async () => {
    const { response } = await getUniversalCasinoOddsAPI(GAME_ID);
    setOdds(response);
  };
  const getLastResult = async () => {
    const { response } = await getUniversalCasinoLastResultAPI(GAME_ID);
    setLastResult(response);
  };
  const getExposure = async () => {
    const { response } = await getCasinoExposureAPI(roundIdRef.current);
    setExposure(response);
  };
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    // Add interval for time condition check
    let timeCheckInterval = setInterval(checkTimeCondition, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeCheckInterval);
    };
  }, [odds?.roundId, odds?.roundWinnerUpdatedAt]);
  useEffect(() => {
    roundIdRef.current = odds?.roundId;
    setTimer(odds?.seconds);
    let interval = setInterval(() => {
      if (odds?.status == "SUSPEND" || timer <= 0) {
        setTimer(0);
      } else {
        setTimer((prev) => prev - 1);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [odds?.roundId]);
  const placeBet = async (
    marketIdWithSelectionId,
    runnerName,
    back,
    isLay = false
  ) => {
    let payload = { ...placeBetPayload };
    payload.marketIdWithSelectionId = `${marketIdWithSelectionId}`;
    payload.runnerName = runnerName;
    payload.back = back;
    if (isLay) {
      payload.lay = back;
      delete payload.back;
    }

    payload.marketId = odds?.roundId;
    payload.amount = 100;
    payload.type = isLay ? "lay" : "back";
    payload.casinoGames = GAME_ID;
    setPlaceBetPayload(payload);
  };
  const placeBetCallApi = async () => {
    setLoading(true);
    const { response, code, status } = await uniCasinoBetAPI(placeBetPayload);
    if (code === 200) {
      toast.success(status);
      getOdds();
      setPlaceBetPayload(null);
    } else {
      toast.error(response);
    }
    setLoading(false);
  };
  React.useEffect(() => {
    getOdds();
    getLastResult();
    let interval = setInterval(() => {
      getOdds();
    }, 800);
    let interval2 = setInterval(() => {
      getLastResult();
    }, 5000);
    let interval3 = setInterval(() => {
      getExposure();
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(interval2);
      clearInterval(interval3);
    };
  }, []);
  const checkTimeCondition = () => {
    const timeA = new Date().getTime();
    const roundWinnerUpdatedAt = odds?.roundWinnerUpdatedAt
      ? new Date(odds.roundWinnerUpdatedAt).getTime()
      : 0;

    if (timeA < roundWinnerUpdatedAt + 3000 && timeA >= roundWinnerUpdatedAt) {
      setShowWinnerOverlay(true);
    } else {
      setShowWinnerOverlay(false);
    }
  };
  return (
    <app-one-day-dragon-tiger
      _nghost-ng-c742108842=""
      className="ng-star-inserted"
    >
      <div _ngcontent-ng-c742108842="">
        <div _ngcontent-ng-c742108842="">
          <app-video-player
            /* style={{ position: "static" }} */
            _ngcontent-ng-c742108842=""
            _nghost-ng-c595356512=""
          >
            <div _ngcontent-ng-c595356512="" className="videoPlayer">
              <CasinoTV casinoGames={GAME_ID} />

              <div
                _ngcontent-ng-c595356512=""
                className="video-overlay ng-star-inserted"
              >
                <div _ngcontent-ng-c595356512="">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="round-id text-white"
                  >
                    RID: {odds?.roundId}
                  </div>
                  {odds?.playerCards?.map((player) => (
                    <div _ngcontent-ng-c595356512="">
                      <h3 _ngcontent-ng-c595356512="" className="text-white">
                        {player?.forPerson}
                      </h3>
                      <div _ngcontent-ng-c595356512="">
                        {player?.cards?.map((card) => (
                          <img
                            _ngcontent-ng-c595356512=""
                            src={`https://casino.queenexch.com/assets/cards/${card?.cardValue}.png`}
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {showWinnerOverlay && (
                <div _ngcontent-ng-c595356512="" className="winnerOverlay">
                  <div
                    _ngcontent-ng-c595356512=""
                    className="mini-result-new active"
                  >
                    <span _ngcontent-ng-c595356512="">
                      {" "}
                      {odds?.roundWinner} win{" "}
                    </span>
                    {/**/}
                  </div>
                  <span
                    _ngcontent-ng-c595356512=""
                    style={{ position: "absolute" }}
                  >
                    <canvas
                      _ngcontent-ng-c595356512=""
                      width="100vw"
                      height="100vh"
                    />
                  </span>
                  {/**/}
                </div>
              )}

              <div _ngcontent-ng-c595356512="" className="timer-overlay">
                <GenericCasinoTimer
                  time={odds?.seconds}
                  status={odds?.status}
                />
              </div>
            </div>

            <div
              _ngcontent-ng-c595356512=""
              id="rulesModal"
              tabIndex={-1}
              aria-labelledby="exampleModalLabelaexampleModalLabela"
              aria-hidden="true"
              className="modal fade"
            >
              <div
                _ngcontent-ng-c595356512=""
                className="modal-dialog rules-wrap"
              >
                <div
                  _ngcontent-ng-c595356512=""
                  role="document"
                  id="rulesList___BV_modal_content_"
                  tabIndex={-1}
                  className="modal-content rules-content"
                >
                  <header
                    _ngcontent-ng-c595356512=""
                    id="rulesList___BV_modal_header_"
                    className="rules-wrap"
                  >
                    <a _ngcontent-ng-c595356512="">
                      <h3
                        _ngcontent-ng-c595356512=""
                        id="rulesList___BV_modal_title_"
                        data-bs-toggle="modal"
                        data-bs-target="#rulesModal"
                        className="modal-title"
                      >
                        {" "}
                        Rules
                      </h3>
                    </a>
                    <button
                      _ngcontent-ng-c595356512=""
                      type="button"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      className="close"
                    >
                      ×
                    </button>
                  </header>
                  <div
                    _ngcontent-ng-c595356512=""
                    id="rulesList___BV_modal_body_"
                    className="modal-body"
                  >
                    <div _ngcontent-ng-c595356512="" id="rulesBoxContainer" />
                  </div>
                  <div _ngcontent-ng-c595356512="">
                    <ul _ngcontent-ng-c595356512="" className="btn-wrap break">
                      <li _ngcontent-ng-c595356512="">
                        <a
                          _ngcontent-ng-c595356512=""
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          className="btnok"
                        >
                          OK
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </app-video-player>
        </div>
        <div
          _ngcontent-ng-c2991413133=""
          id="marketScroll"
          style={{ overflowY: "auto", height: 616 }}
          className="overflow-auto"
        >
          {odds?.markets?.map((item) => (
            <div _ngcontent-ng-c742108842="" className="scrollMarket">
              <div
                _ngcontent-ng-c742108842=""
                className="card ng-star-inserted"
              >
                <span
                  _ngcontent-ng-c742108842=""
                  data-bs-toggle="collapse"
                  data-bs-target="#multiCollapseExample19132202182917"
                  role="button"
                  aria-expanded="true"
                  aria-controls="multiCollapseExample1"
                  className="btn btn-primary card-header inner-sportbook"
                >
                  <span _ngcontent-ng-c742108842="">
                    <strong _ngcontent-ng-c742108842="">
                      {item?.marketName}
                    </strong>
                  </span>
                  <span _ngcontent-ng-c742108842="" />
                </span>
                <div _ngcontent-ng-c742108842="" className="col">
                  <div
                    _ngcontent-ng-c742108842=""
                    className="collapse multi-collapse show"
                    id="multiCollapseExample19132202182917"
                  >
                    {odds?.status == "SUSPEND" && (
                      <div
                        _ngcontent-ng-c742108842=""
                        className="suspended-casino ng-star-inserted"
                      >
                        <span
                          _ngcontent-ng-c742108842=""
                          className="stats-text"
                        >
                          Suspended
                        </span>
                      </div>
                    )}

                    <table
                      _ngcontent-ng-c742108842=""
                      className="table table-hover tbl-bets p-rltv sportbook-market-tbl"
                    >
                      <colgroup _ngcontent-ng-c742108842="">
                        <col _ngcontent-ng-c742108842="" span={1} width="60%" />
                        <col
                          _ngcontent-ng-c742108842=""
                          span={1}
                          width="20%"
                          className="back-1 count"
                        />
                        <col
                          _ngcontent-ng-c742108842=""
                          span={1}
                          width="20%"
                          className="back-1 count"
                        />
                      </colgroup>
                      <tbody>
                        <tr _ngcontent-ng-c742108842="">
                          <th
                            _ngcontent-ng-c742108842=""
                            colSpan=""
                            className="min-max-mobile d-flex justify-content-center"
                          >
                            <dl
                              _ngcontent-ng-c742108842=""
                              id="minMaxBox"
                              className="fancy-info"
                            >
                              <dt _ngcontent-ng-c742108842="">
                                Min/Max &nbsp;
                              </dt>
                              <dd _ngcontent-ng-c742108842="" id="minMaxInfo">
                                {" "}
                                {item?.min} - {item?.max}{" "}
                              </dd>
                            </dl>
                          </th>
                          <th
                            _ngcontent-ng-c742108842=""
                            className="back-1 count"
                          >
                            Back
                          </th>
                          <th _ngcontent-ng-c742108842="" className="lay">
                            Lay
                          </th>
                        </tr>
                        {item?.oddDetailsDTO?.map((odd) => (
                          <>
                            <tr
                              _ngcontent-ng-c742108842=""
                              className="odd-row ng-star-inserted"
                            >
                              <td
                                _ngcontent-ng-c742108842=""
                                colSpan=""
                                className="team-name sportbook-name"
                              >
                                <span
                                  _ngcontent-ng-c742108842=""
                                  className="title ng-star-inserted"
                                >
                                  {" "}
                                  {odd?.runnerName}{" "}
                                </span>
                                {getUniversalCasinoPlExposureByRunner(
                                  exposure,
                                  odd?.runnerName
                                )}
                              </td>
                              <td
                                _ngcontent-ng-c742108842=""
                                colSpan=""
                                appratehighlight=""
                                className="back-1 count sportbook-minwidth p-rltv"
                              >
                                <a
                                  onClick={() =>
                                    placeBet(
                                      `${item?.marketId}_${odd?.selectionId}`,
                                      odd?.runnerName,
                                      odd?.back1
                                    )
                                  }
                                  _ngcontent-ng-c742108842=""
                                  className="d-flex flex-column p-0"
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                                  {" "}
                                  {odd?.back1}{" "}
                                  <span
                                    _ngcontent-ng-c742108842=""
                                    className="d-flex justify-content-center"
                                  >
                                    {odd?.backSize1}
                                  </span>
                                </a>
                              </td>
                              <td
                                _ngcontent-ng-c742108842=""
                                colSpan=""
                                appratehighlight=""
                                className="lay count sportbook-minwidth p-rltv"
                              >
                                <a
                                  onClick={() =>
                                    placeBet(
                                      `${item?.marketId}_${odd?.selectionId}`,
                                      odd?.runnerName,
                                      odd?.lay1,
                                      true
                                    )
                                  }
                                  _ngcontent-ng-c742108842=""
                                  className="d-flex flex-column p-0"
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                  }}
                                >
                                  {odd?.lay1}{" "}
                                  <span
                                    _ngcontent-ng-c742108842=""
                                    className="d-flex justify-content-center"
                                  >
                                    {odd?.laySize1}
                                  </span>
                                </a>
                              </td>
                            </tr>
                            {placeBetPayload?.marketIdWithSelectionId ==
                              `${item?.marketId}_${odd?.selectionId}` && (
                              <PlaceBetUniversal
                                placeBetPayload={placeBetPayload}
                                setPlaceBetPayload={setPlaceBetPayload}
                                placeBet={placeBetCallApi}
                              />
                            )}
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <GetUniversalLastTenResult lastResult={lastResult} />
            </div>
          ))}
        </div>
      </div>
    </app-one-day-dragon-tiger>
  );
}
